<template>
    <div class="pl-3 pr-3">
        <AppPushNotification ref="notification" :title="notificationModel.title" :text="notificationModel.text"
            :color="notificationModel.color" />
        <div>
            <div class=" text-center mt-4">
                <div @click="triggerFileInput" class="avatar-wrapper">
                    <img class="avatarImgEdit" :src="userProfile.avatar" alt="">
                    <div class="icon-pencil">
                        <i style="margin: 1.5cap;" class="fi fi-rr-pencil"></i>
                    </div>
                    <input accept=".png, .jpeg, .jpg" type="file" ref="fileInput" @change="handleFileUpload"
                        class="d-none">
                </div>
                <div class="text-left mt-4">
                    <div>
                        <label class="h5">{{ $t('fistname') }} - {{ $t('lastname') }}</label>
                        <input @change="setPosition()" v-model="userProfile.name" class="form-control-theme" />
                    </div>
                    <div class="mt-4 position-relative">
                        <label class="h5">{{ $t('email') }} ({{ $t('noRequired') }})</label>
                        <input @change="setPosition(); validateEmail()" v-model="userProfile.email"
                            class="form-control-theme-badge pr-5" />
                    </div>

                    <div v-if="userProfile.provider == 'EMAIL' || userProfile.provider == 'GMAIL'"
                        class="form-group position-relative mt-4">
                        <label class="h5">{{ $t('registerEmail') }}</label>
                        <input readonly v-model="userProfile.registeredEmail" class="form-control-theme" />
                        <i class="fi fi-rr-lock show-password-btn"></i>
                    </div>

                    <div v-show="isPhoneNumber" class="form-group position-relative mt-4">
                        <label class="h5">{{ $t('phoneNumber') }}</label>
                        <input readonly v-model="userProfile.phone" class="form-control-theme" />
                        <i class="fi fi-rr-lock show-password-btn"></i>
                    </div>

                    <CButton :disabled="loading" @click="saveUser()" block class="btn-color-theme bg-color-theme mt-4">
                        <CSpinner v-if="loading" class="mb-1" component="span" size="sm" aria-hidden="true" /> {{
                            $t('save') }}
                    </CButton>
                    <div class="text-description text-center mt-4">
                        {{ $t('termAndPolicy1') }} <a rel="noreferrer" href="">{{ $t('termAndPolicy') }}</a>
                        {{
                            $t('termAndPolicy2') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import util from '@/util/util'
import '@/util/delivery.css'
import AppPushNotification from '@/components/AppPushNotification.vue'
import pos from '@/services/pos'


export default {
    components: {
        AppPushNotification
    },
    data() {
        return {
            editable: true,
            notificationModel: {
                title: '',
                text: '',
                color: '',
            },
            userProfile: {},
            loading: false,
            isEmailValid: Boolean,
        }
    },
    mounted() {

    },
    beforeDestroy() {

    },
    computed: {
        ...mapGetters(['shopLineOA']),
        token() {
            return localStorage.getItem('token') || null
        },
        uid() {
            return `${localStorage.getItem('uid')}`
        },
        shopObjectId() {
            return `${localStorage.getItem('shopObjectId')}`
        },
        shop() {
            return this.shopLineOA.find(
                (detail) => detail.objectId === this.shopObjectId
            )
        },
        shopName() {
            if (this.shop) {
                return this.shop.shopName
            } else {
                return ''
            }
        },
        logo() {
            if (this.shop) {
                return this.shop.remoteImagePath
            } else {
                return ''
            }
        },
        noImg() {
            return process.env.VUE_APP_NOIMAGE
        },
        profileObjectId() {
            return localStorage.getItem('profileObjectId') || null
        },
        isPhoneNumber() {
            const profile = JSON.parse(localStorage.getItem('profile')) || null
            const phone = profile?.phone || null
            const phoneRegex = /^(08|09|06)\d{8}$/
            return phoneRegex.test(phone)
        },
    },
    created() {
        this.getUserProfileDetails()
    },
    beforeDestroy() {

    },
    methods: {
        ...util,
        validateEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            this.isEmailValid = emailRegex.test(this.userProfile.email);
        },
        setPosition() {
            window.scrollTo(0, 0)
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const img = new Image();
                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');
                        const size = 200;

                        // Calculate the dimensions and position for center-cropping
                        const minSize = Math.min(img.width, img.height);
                        const startX = (img.width - minSize) / 2;
                        const startY = (img.height - minSize) / 2;

                        canvas.width = size;
                        canvas.height = size;

                        // Draw the cropped image to the canvas
                        ctx.drawImage(img, startX, startY, minSize, minSize, 0, 0, size, size);
                        this.userProfile.avatar = canvas.toDataURL(file.type);
                        this.$forceUpdate();
                    };
                    img.src = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        },
        async getUserProfileDetails() {
            try {
                if (localStorage.getItem('token')) {
                    const phone = localStorage.getItem('phone')
                    const uid = localStorage.getItem('uid')
                    const res = await pos({
                        url: `/api/v1.3/${uid}/profile?objectId=${this.profileObjectId}`,
                        method: 'get',
                    });
                    if (res.data.error.code == 0) {
                        this.userProfile = res.data?.data || {}
                        this.userProfile.avatar ||= 'https://cdn-icons-png.flaticon.com/512/847/847969.png';
                        console.log(this.userProfile)

                    } else if (res.data.error.code == 402) {
                        this.renewToken()
                    } else if (res.data.error.code == 4000) {
                        this.logOut()
                    }
                }
            } catch (error) {
                this.showNotification(error, '', 'danger')
                console.error(error);
            }
        },
        async renewToken() {
            try {
                if (localStorage.getItem('refreshToken')) {
                    const refreshToken = localStorage.getItem('refreshToken')

                    let res = {}
                    res = await pos({
                        url: `/auth/v1.0/renewtoken/otp`,
                        method: 'post',
                        data: {
                            "refreshToken": refreshToken
                        }
                    });
                    if (res.data?.error?.code == 0) {
                        localStorage.setItem('token', res.data?.data?.token)
                        window.location.reload()
                    } else {
                        this.logOut()
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
        logOut() {
            const uid = localStorage.getItem('uid')
            const shopObjectId = localStorage.getItem('shopObjectId')
            sessionStorage.clear()
            localStorage.clear()
            localStorage.setItem('uid', uid)
            localStorage.setItem('shopObjectId', shopObjectId)
            this.$router.push('/delivery/home')
        },
        showNotification(title, text, color) {
            this.notificationModel = {
                color: color,
                title: title,
                text: text,
            }
            this.$refs.notification.pushNotification();
        },
        async saveUser() {
            try {
                this.loading = true;
                const uid = localStorage.getItem('uid');

                let data = {
                    name: this.userProfile.name,
                    phone: this.userProfile.phone,
                    email: this.userProfile.email,
                };

                // Check if avatar is a base64 string
                if (typeof this.userProfile.avatar === 'string' && this.userProfile.avatar.startsWith('data:image/')) {
                    data.avatar = this.userProfile.avatar;
                }

                if (this.userProfile.name) {
                    try {
                        const res = await pos({
                            url: `/api/v1.3/${uid}/profile`,
                            method: 'patch',
                            data: data,
                        });

                        const { code } = res.data.error;
                        this.showNotification(code === 0 ? this.$i18n.t('saveSuccess') : `ERROR ${code}`, '', code === 0 ? 'success' : 'danger');

                        if (code === 0) {
                            this.getUserProfileDetails();
                            this.setPosition();
                        }
                    } finally {
                        this.loading = false;
                    }
                } else {
                    const errorMsg = !this.userProfile.name ? this.$i18n.t('nameInputInvalid') : this.$i18n.t('validateEmail');
                    this.showNotification(errorMsg, '', 'danger');
                    this.loading = false;
                }

            } catch (error) {
                this.showNotification('ERROR ' + error, '', 'danger')
                console.error(error)
            }
        },
        trackButtonClick(buttonLabel) {
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'click', {
                    event_label: buttonLabel,
                });
            } else {
                console.error('gtag is not defined.');
            }
        },
    },

}
</script>
<style>
.show-password-btn {
    position: absolute;
    right: 1.0rem;
    top: 2.7rem;
    z-index: 2;
    font-size: 1.3rem;
    color: #777777;
}
</style>